export enum ENV {
  DEV = "dev",
  PROD = "prod",
  LOCAL = "local",
  TEST = "test",
}

export enum LANGUAGES {
  EN = "en",
  AR = "ar",
}

export enum LOCAL_STORAGE_KEYS {
  THEME = "theme",
  LANGUAGE = "language",
  LOGIN_EMAIL = "login_email",
  SESSION_TOKEN = "session_token",
  REFRESH_TOKEN = "refresh_token",
  PRODUCTS_VIEW_MODE = "products_view_mode",
  INTENDED_PATH = "intended_path",
}

export const PASSWORD_RULES = [
  {
    min: 8,
    message: "message.error.password_min_length",
  },
  {
    pattern: /.*[a-z].*/,
    message: "message.error.one_lowercase_required",
  },
  {
    pattern: /.*[A-Z].*/,
    message: "message.error.one_uppercase_required",
  },
  {
    pattern: /.*\d.*/,
    message: "message.error.one_digit_required",
  },
  {
    pattern: /.*[!@#+$%^&*(),.?":{}|<>].*/,
    message: "message.error.one_symbol_required",
  },
  {
    pattern: /^\S*$/,
    message: "message.error.no_spaces_allowed",
  },
];

export const PRODUCT_IMAGE_PLACHOLDER =
  "https://robinfood-media.s3.me-south-1.amazonaws.com/DALL%C2%B7E+2024-08-10+13.49.37+-+A+realistic+food+placeholder+image+featuring+a+clean+white+plate+centered+on+a+light+wooden+table%2C+with+a+simple+fork+and+knife+placed+neatly+on+eithe.webp";

export enum VIEW_MODE {
  GRID = "grid",
  LIST = "list",
}

export const DEFAULT_LAT = 21.422617;
export const DEFAULT_LNG = 39.826268;

export const mapConfig = {
  mapTheme: [
    {
      featureType: "all",
      elementType: "labels.text",
      stylers: [
        {
          color: "#878787",
        },
      ],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f9f5ed",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          color: "#f5f5f5",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#c9c9c9",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#aee0f4",
        },
      ],
    },
  ],
};
